(() => {
  const root = document.documentElement;
  root.classList.remove('no-js');
  root.classList.add('js');

  const focusableSelector = [
    'a[href]',
    'button:not([disabled])',
    'summary',
    'input:not([disabled])',
    'select:not([disabled])',
    'textarea:not([disabled])',
    '[tabindex]:not([tabindex="-1"])',
  ].join(',');

  const refreshPageLock = () => {
    root.classList.toggle('menu-open', Boolean(document.querySelector('[data-menu-drawer][open]')));
  };

  const closeDrawer = (drawer, restoreFocus = true) => {
    if (!drawer.open) return;

    const summary = drawer.querySelector(':scope > summary');
    drawer.open = false;
    summary?.setAttribute('aria-expanded', 'false');
    refreshPageLock();

    if (restoreFocus) summary?.focus();
  };

  const trapFocus = (event, container) => {
    if (event.key !== 'Tab') return;

    const focusable = [...container.querySelectorAll(focusableSelector)].filter(
      (element) => !element.hasAttribute('hidden') && element.getClientRects().length > 0,
    );

    if (!focusable.length) return;

    const first = focusable[0];
    const last = focusable[focusable.length - 1];

    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  };

  const initializeMenuDrawer = (drawer) => {
    if (drawer.dataset.naturalInitialized === 'true') return;
    drawer.dataset.naturalInitialized = 'true';

    const summary = drawer.querySelector(':scope > summary');
    const panel = drawer.querySelector('.menu-drawer__panel');
    const closeButton = panel?.querySelector('[data-menu-close]');

    drawer.querySelectorAll('[data-menu-close]').forEach((button) => {
      button.addEventListener('click', () => closeDrawer(drawer));
    });

    drawer.querySelectorAll('a[href]').forEach((link) => {
      link.addEventListener('click', () => closeDrawer(drawer, false));
    });

    drawer.addEventListener('toggle', () => {
      summary?.setAttribute('aria-expanded', drawer.open ? 'true' : 'false');

      if (drawer.open) {
        document.querySelectorAll('[data-menu-drawer][open]').forEach((otherDrawer) => {
          if (otherDrawer !== drawer) closeDrawer(otherDrawer, false);
        });

        refreshPageLock();
        window.requestAnimationFrame(() => closeButton?.focus());
      } else {
        refreshPageLock();
      }
    });

    panel?.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') {
        event.preventDefault();
        closeDrawer(drawer);
        return;
      }

      trapFocus(event, panel);
    });
  };

  const initializeDesktopDisclosure = (disclosure) => {
    if (disclosure.dataset.naturalInitialized === 'true') return;
    disclosure.dataset.naturalInitialized = 'true';

    disclosure.addEventListener('toggle', () => {
      if (!disclosure.open) return;

      document.querySelectorAll('[data-desktop-disclosure][open]').forEach((otherDisclosure) => {
        if (otherDisclosure !== disclosure) otherDisclosure.open = false;
      });
    });

    disclosure.addEventListener('keydown', (event) => {
      if (event.key !== 'Escape') return;

      event.preventDefault();
      disclosure.open = false;
      disclosure.querySelector(':scope > summary')?.focus();
    });
  };

  const initializeShell = (scope = document) => {
    scope.querySelectorAll('[data-menu-drawer]').forEach(initializeMenuDrawer);
    scope.querySelectorAll('[data-desktop-disclosure]').forEach(initializeDesktopDisclosure);
  };

  let headerFrame = 0;
  const updateStickyHeader = () => {
    headerFrame = 0;
    document.querySelectorAll('[data-natural-header]').forEach((header) => {
      header.classList.toggle('is-scrolled', window.scrollY > 2);
    });
  };

  const queueStickyHeaderUpdate = () => {
    if (headerFrame) return;
    headerFrame = window.requestAnimationFrame(updateStickyHeader);
  };

  initializeShell();
  updateStickyHeader();
  window.addEventListener('scroll', queueStickyHeaderUpdate, { passive: true });

  document.addEventListener('click', (event) => {
    document.querySelectorAll('[data-desktop-disclosure][open]').forEach((disclosure) => {
      if (!disclosure.contains(event.target)) disclosure.open = false;
    });
  });

  const desktopQuery = window.matchMedia('(min-width: 990px)');
  desktopQuery.addEventListener('change', (event) => {
    if (!event.matches) return;
    document.querySelectorAll('[data-menu-drawer][open]').forEach((drawer) => closeDrawer(drawer, false));
  });

  document.addEventListener('shopify:section:load', (event) => {
    initializeShell(event.target);
    updateStickyHeader();
  });

  const updateCartCount = (itemCount) => {
    if (!Number.isFinite(itemCount)) return;

    const count = Math.max(0, itemCount);
    const badges = document.querySelectorAll('[data-cart-count]');
    const cartLinks = document.querySelectorAll('[data-cart-link]');
    const status = document.querySelector('#NaturalStatus');
    const itemLabel = count === 1 ? 'item' : 'items';

    badges.forEach((badge) => {
      badge.textContent = String(count);
      badge.hidden = count === 0;
    });

    cartLinks.forEach((cartLink) => {
      cartLink.setAttribute('aria-label', `Cart, ${count} ${itemLabel}`);
    });
    if (status) status.textContent = `${count} ${itemLabel} in cart`;
  };

  document.addEventListener('cart:updated', (event) => {
    updateCartCount(Number(event.detail?.cart?.item_count));
  });
})();
